/// <reference types="@types/gtag.js" />

import { isProdEnv } from '@/config/runtime-env'

type GaEvent = GaDealSignUpEvent | GaHomePageEvent

type GaDealSignUpEvent = {
  event: 'deal_signup'
  room_name: string
  deal_id: string
}

type GaHomePageEvent = {
  event:
    | 'home_top_create_account'
    | 'home_top_login'
    | 'home_top_view_deals'
    | 'home_room_details'
    | 'home_get_deal'
    | 'home_view_all_deals_top'
    | 'home_discord_top'
    | 'home_whatsapp_top'
    | 'home_telegram_top'
    | 'home_email_top'
    | 'home_get_your_bonuses_now'
    | 'home_unlock_your_rewards_now'
    | 'home_get_rewarded'
    | 'home_discord_bottom'
    | 'home_whatsapp_bottom'
    | 'home_telegram_bottom'
    | 'home_email_bottom'
    | 'home_find_deal'
  deal_id?: string
}
const EVENT_PREFIX = 'rw_'

function isGtagAvailable(): boolean {
  return typeof window !== 'undefined' && 'gtag' in window && typeof gtag === 'function'
}

export function sendGaEvent(event: GaEvent) {
  if (isProdEnv()) {
    const { event: eventName, ...params } = event

    if (!isGtagAvailable()) {
      return
    }

    // A dataLayer push runs gtag's own handlers synchronously on this stack, so a defect in them
    // throws into the caller. FRONTEND-3112 is the container-side version of that same shape, on
    // a page that still loaded one. Every call site here is a click handler on a
    // `component={Link}` CTA, so an escaped throw aborts the handler before React Router's own
    // click handler runs — the SPA navigation degrades to a full page reload and the hit is lost
    // anyway. Fenced locally rather than via `@gto/analytics`: this app depends on neither that
    // library nor Sentry, so the shared helper's reporting would have nowhere to go.
    try {
      gtag('event', `${EVENT_PREFIX}${eventName}`, {
        ...params,
        event_category: 'engagement',
        event_label: eventName,
      })
    } catch (error) {
      console.warn('rakeback.sendGaEvent: gtag threw, hit dropped', error)
    }
  }
}
